import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { TAB_NAME } from '@/components/DataGenerationHistory/constants';
import { useGetDownloadHistory } from '@/components/DataGenerationHistory/hooks/useGetDownloadHistory';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import { styles } from './styles';

export const DrawerHeader = () => {
  const setOpen = downloadHistoryStore.use.setOpen();
  const { getDownloadHistory } = useGetDownloadHistory({
    fetchPolicy: 'network-only',
  });

  return (
    <Box component='header' sx={styles.drawerHeaderContainer}>
      <Box sx={styles.drawerHeaderContent}>
        <Typography variant='caption' sx={styles.drawerHeaderTitle}>
          {TAB_NAME}
        </Typography>

        <IconButton
          onClick={() => getDownloadHistory()}
          size='small'
          sx={styles.drawerHeaderRefreshButton}
        >
          <RefreshIcon fontSize='small' />
        </IconButton>

        <IconButton onClick={() => setOpen(false)} size='small' sx={styles.drawerHeaderCloseButton}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </Box>
      <Divider sx={styles.drawerHeaderDivider} />
    </Box>
  );
};
